export default __webpack_public_path__ + "static/media/SONDAGE.3bbac3fb.svg";